module.exports = __webpack_public_path__ + "static/media/testimonial_image_1.bbdaf549.svg";